RivalIQ.module('logger', function (logger, App, Backbone, Marionette, $, _, moment, console) {

    'use strict';

    const logTransports = {};

    /**
     * A log transport for the developer console.
     * @param message
     */
    logTransports.console = function (type, message) {

        if (console) {

            logTransports.console = function (type, message) {

                if (console[type]) {

                    return console[type](message);
                }

                console.log(message);
            };
        } else {

            logTransports.console = _.noop;
        }

        logTransports.console(type, message);
    };

    (function () {

        const buffer = [];

        /**
         * A log transport for a buffer (array).
         * @param message
         */
        logTransports.buffer = function (type, message) {

            buffer.push(message);
        };

        // expose backing data
        logTransports.buffer._data = buffer;

    }());

    // use the system level transports
    let transports = _.values(logTransports);

    const logLevels = {
        debug: 'debug',
        info: 'info',
        warn: 'warn',
        error: 'error'
    };

    /**
     * Log a specified message at a specified level to enabled transports.
     * @param level The log level.
     * @param message The format string or message.
     */
    function log(level, message) {

        const formattedMessage = `${moment.utc().format()} - ${level}: ${message}`;

        for (let transport, i = 0, l = transports.length; i < l; i++) {

            transport = transports[i];
            transport(level, formattedMessage);
        }
    }

    logger.log = log;

    _.each(logLevels, function (name, logLevel) {

        logger[name] = _.bind(logger.log, null, logLevel);
    });

    /**
     * Gets an array of the defined log transports.
     * @returns {*}
     */
    logger.getTransports = function () {

        return transports;
    };

    /**
     * Sets the array of defined log transports.
     * @param t An array of transports.
     */
    logger.setTransports = function (t) {

        transports = t;
    };

}, window.moment, window.console);
